module.exports = __webpack_public_path__ + "img/login-graphic.a863f9e3.png";